<ng-container *ngIf="brands.length >= minimumBrands">
  <app-brand-list
    [brands]="brands"
    [isMobile]="isMobile"
    [limit]="limit"
  ></app-brand-list>
</ng-container>
